import { PlacementXAnchor, PlacementYAnchor, TextAlignment, TextVerticalAlignment } from "common/utils/textAlignment";

export enum AnnotationType {
  LINEAR_DIMENSION = "LINEAR_DIMENSION",
  NOTE = "NOTE",
  LINEWORK = "LINEWORK",
  DETAIL = "DETAIL",

  // DEPRECATED
  PLAN_DIM = "PLAN_DIM",
}

export enum AnnotationLineType {
  CONTINUOUS = "CONTINUOUS",
  DASHED_LARGE = "DASHED_LARGE",
  DASHED_SMALL = "DASHED_SMALL",
  CENTERLINE = "CENTERLINE",
  DOTTED = "DOTTED",
  NONE = "NONE",
}

export enum AnnotationFillType {
  SOLID_WHITE = "SOLID_WHITE",
  SOLID_20PCT_GRAY = "SOLID_20PCT_GRAY",
  SOLID_40PCT_GRAY = "SOLID_40PCT_GRAY",
  SOLID_60PCT_GRAY = "SOLID_60PCT_GRAY",
  CROSSHATCH = "CROSSHATCH",
  DIAGONAL_DOWN = "DIAGONAL_DOWN",
  DIAGONAL_UP = "DIAGONAL_UP",
  GRID = "GRID",
  NONE = "NONE",
}

export enum PositioningMethod {
  EDGE = "EDGE",
  GLOBAL = "GLOBAL",
}

export { TextAlignment, TextVerticalAlignment, PlacementXAnchor, PlacementYAnchor };

export enum PathEndStyle {
  NONE = "NONE",
  ARROW = "ARROW",
}

export enum PaperSize {
  SHEET_11X17 = "SHEET_11X17",
  SHEET_22X34 = "SHEET_22X34",
}

export enum TextBackground {
  OUTLINE = "OUTLINE",
  SOLID = "SOLID",
}
